import { IHost } from '@/types/models';

function getHostUniqueName(host: IHost) {
  return `${host.hostName}${host.nodeName}`;
}

export default getHostUniqueName;
